<template>
  <div class="improveInfo">
    <Personal-center-head>
      <div>完善信息</div>
    </Personal-center-head>

    <div class="improveInfo-content">
      <el-form :model="ruleForm" :rules="rules" size="small" ref="ruleForm" class="demo-ruleForm" label-position="top"
        label-width="80px">
        <el-form-item label="头像">
          <el-upload name="file" class="avatar-uploader" action="https://laravel.gongshicloud.com/api/index/upload"
            :show-file-list="false" :on-success="handleAvatarSuccess" :data="{ file: 'file', model: '' }" ref="imageUrl">
            <div class="head-upload">
              <img v-if="imageUrl" :src="imageUrl">
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="默认密码">
          <el-input placeholder="123456" :disabled="true" style="width:400px">
          </el-input>
        </el-form-item>
        <el-form-item label="职业" prop="userTypeId">
          <el-select v-model="ruleForm.userTypeId" placeholder="请选择职业" style="width:400px" @change="change">
            <el-option v-for="item in vocationList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="listIndex == 2 ? '专家姓名' : '联系人'" prop="realname">
          <el-input style="width:740px" type="text" v-model="ruleForm.realname" autocomplete="off"
            :placeholder="listIndex == 2 ? '请输入专家姓名' : '请输入联系人'"></el-input>
        </el-form-item>
        <!-- 选择职业后显示  开始-->
        <div v-if="listIndex == 1">
          <declare :ruleForm="ruleForm" />
        </div>
        <div v-if="listIndex == 2">
          <specialist :ruleForm="ruleForm" />
        </div>
        <div v-if="listIndex == 3">
          <learn-society :ruleForm="ruleForm" />
        </div>
        <div v-if="listIndex == 4">
          <fund :ruleForm="ruleForm" />
        </div>
        <div v-if="listIndex == 5">
          <enterprise :ruleForm="ruleForm" />
        </div>
        <div v-if="listIndex == 6">
          <magazine :ruleForm="ruleForm" />
        </div>
        <div v-if="listIndex == 7">
          <mediafirm :ruleForm="ruleForm" />
        </div>
        <div v-if="listIndex == 9">
          <executor :ruleForm="ruleForm" />
        </div>
        <div v-if="listIndex == 8">
          <other :ruleForm="ruleForm" />
        </div>
        <!-- 选择职业后显示  结束-->
        <!-- 手机号、验证码、密码、邮箱、联系人 -->
        <!-- 邮箱 -->
        <el-form-item label="邮箱" prop="email">
          <el-input style="width:500px" type="text" v-model="ruleForm.email" autocomplete="off"
            placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <!-- 手机号、验证码、密码、邮箱、联系人 结束 -->
        <el-form-item>
          <el-button type="primary" style="background: #484c7f" @click="submitForm('ruleForm')">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import PersonalCenterHead from '../../components/PersonalCenterHead/index.vue'
import getCode from '../../components/getCode/index.vue'
import declare from './declare.vue'
import specialist from './specialist.vue'
import learnSociety from './learnSociety.vue'
import fund from './fund.vue'
import enterprise from './enterprise.vue'
import magazine from './magazine.vue'
import mediafirm from './mediafirm.vue'
import executor from './Executor.vue'
import other from './other'
export default {
  name: 'improveInfo',
  components: {
    PersonalCenterHead,
    getCode,
    declare,
    specialist,
    learnSociety,
    fund,
    enterprise,
    magazine,
    mediafirm,
    executor,
    other
  },
  data() {
    return {
      listIndex: 0,
      vocationList: [],
      userinfo: {},
      imageUrl: require('../../assets/image/avatar.png'),
      ruleForm: {
        //默认校验
        userTypeId: '', //用户身份
        avatar: '', //头像
        realname: '',//真实姓名
        email: '',//邮箱 
        json: {
          //申报人
          //专家
          hospital: '',//所在医院
          department: '',//所属科室
          title: '',//职称  
          //学会
          user: '',//名称
          XLlevel: '',//类别
          //基金会 
          user: '',//名称
          XLlevel: '',//类别 
          //企业
          user_name: '',//名称
          i_id: '',//细分
          d_id: '',//部门
          p_id: '',//职位
          //address: '',//办公地址 
          //期刊
          level: '',//级别 
          level_user_name: '',
          //媒体 
          user_name: '',//名称 
          MTlevel: '',//类型 
          PlatformClassifieds: '',//分类
          meeting_mode: '',//线上地址
          offline_address: '',//线下地址
          //执行方
          ZXFlevel: '',//分类
          ZXFname: '',//名称 
          //其他   
        }
      },
      rules: {
        //默认
        userTypeId: [
          { required: true, message: '请选择职业', trigger: 'change' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' }
        ],
        realname: [
          { required: true, message: '请输名称', trigger: 'blur' }
        ],
        //专家  
        'json.hospital': [
          { required: true, message: '请输入所在医院', trigger: 'change' }
        ],
        'json.department': [
          { required: true, message: '请选择所在科室', trigger: 'change' }
        ],
        'json.title': [
          { required: true, message: '请输入专家职称', trigger: 'change' }
        ],
        //学会
        'json.user': [
          { required: true, message: '请输入学会名称', trigger: 'change' }
        ],
        'json.XLlevel': [
          { required: true, message: '请选择学会类别', trigger: 'change' }
        ],
        //基金会
        'json.user': [
          { required: true, message: '请输入基金会名称', trigger: 'change' }
        ],
        'json.XLlevel': [
          { required: true, message: '请选择基金会类别', trigger: 'change' }
        ],
        //企业 
        'json.user_name': [
          { required: true, message: '请输入企业名称', trigger: 'change' }
        ],
        'json.i_id': [
          { required: true, message: '请选择行业细分', trigger: 'change' }
        ],
        'json.d_id': [
          { required: true, message: '请选择部门', trigger: 'change' }
        ],
        'json.p_id': [
          { required: true, message: '请选择职位', trigger: 'change' }
        ],
        // 'json.address': [
        //   { required: true, message: '请输入办公地址', trigger: 'change' }
        // ],
        //期刊
        'json.level': [
          { required: true, message: '请选择期刊级别', trigger: 'change' }
        ],
        'json.level_user_name': [
          { required: true, message: '请输入期刊名称', trigger: 'change' }
        ],
        //媒体
        'json.user_name': [
          { required: true, message: '请输入媒体名称', trigger: 'change' }
        ],
        'json.MTlevel': [
          { required: true, message: '请选择媒体级别', trigger: 'change' }
        ],
        'json.PlatformClassifieds': [
          { required: true, message: '请选择平台类型', trigger: 'change' }
        ],
        'json.meeting_mode': [
          { required: true, message: '请选择线上平台', trigger: 'change' }
        ],
        'json.offline_address': [
          { required: true, message: '请输入线下平台', trigger: 'change' }
        ],
        //执行方 
        'json.ZXFlevel': [
          { required: true, message: '请选择执行方分类', trigger: 'change' }
        ],
        'json.ZXFname': [
          { required: true, message: '请选择执行名称', trigger: 'change' }
        ],
        //其他 
      }
    }
  },
  created() {
    this.getMe()
    this.getVocation()
  },
  methods: {
    //获取职业
    async getVocation() {
      const { data: data } = await this.$http.get('user/type')
      this.vocationList = data.data
    },
    //选择职业
    change(e) {
      this.listIndex = e
    },
    //获取个人信息 
    async getMe() {
      const { data: data } = await this.$http.post('me')
      this.userinfo = data.data
      this.imageUrl = data.data.avatar
      this.ruleForm.avatar = data.data.avatar
    },
    //图片上传成功
    handleAvatarSuccess(res, file, fileList) {
      if (res.code != 200) {
        this.$refs.imageUrl.clearFiles()
        this.$message.error(res.message)
        return
      }
      this.$Loading.finish()
      this.imageUrl = URL.createObjectURL(file.raw);
      this.ruleForm.avatar = res.data.url
    },
    //提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ceshi(this.ruleForm)
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //筛选数据 最后返给后台
    ceshi(value) {
      for (let k in value.json) {
        if (value.json[k] == '') {
          delete value.json[k]
        }
      }
      this.getSubmitApi(value)
    },
    //提交接口
    async getSubmitApi(Parameters) {
      const { data: data } = await this.$http.post('user/changeInfo', Parameters)
      this.$router.push('/home')
      localStorage.removeItem("code");
      this.$message({
        message: data.message,
        type: 'success'
      });
    }
  }
}

</script>
<style lang="less" scoped>
.improveInfo {
  // padding: 50px 0;
  // height: 98%;

  .improveInfo-content {
    min-height: 700px;

    width: 100%;
    margin-top: 23px;
    padding: 25px 20px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    border-radius: 8px;
    background-color: #fff;
    //overflow: hidden;

    .head-upload {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
      }
    }

    & /deep/ .el-form-item__label {
      // font-size: 16px;
      color: #212529;
      padding-bottom: 15px;
      line-height: 16px;

      &::before {
        content: "*";
        color: #ff0000;
        padding-right: 5px;
        font-weight: 600;
      }
    }

    // & /deep/ .el-input__inner {
    //   height: 35px;
    // }

    .proving-code {
      display: flex;

      :nth-child(2) {
        margin-left: 25px;
      }
    }
  }
}
</style>